import { css } from 'components/_UI/designSystem';
import { fontStackNormalString } from 'components/spaceKit';

const selectStyles = css`
    position: relative;
    display: flex;
    flex: 1 1 auto;
    font-family: ${fontStackNormalString};

    .Select {
        position: relative;
        display: flex;
        flex: 1 1 auto;
        font-family: ${fontStackNormalString};
    }

    .Select,
    .Select div,
    .Select input,
    .Select span {
        box-sizing: border-box;
        white-space: normal;
    }
    .Select.is-disabled > .Select-control:hover {
        box-shadow: none;
    }
    .Select.is-disabled .Select-arrow-zone {
        cursor: default;
        pointer-events: none;
    }
    .Select.is-disabled.Select--single > .Select-control .Select-value .Select-value-label {
        color: ${({ theme }) => theme && theme.type.soft};
    }
    .Select-control {
        cursor: default;
        display: table;
        border-spacing: 0;
        border-collapse: separate;
        height: 36px;
        outline: none;
        overflow: hidden;
        position: relative;
        width: 100%;
        max-width: 1000px;
        padding: 5px 36px 5px 8px;
        border-radius: 2px;
        background: ${({ theme }) => theme && theme.select.control.default.background};
        border: 1px solid ${({ theme }) => theme && theme.select.control.default.border};
    }

    .Select-control .Select-input:focus {
        outline: none;
    }
    .is-searchable.is-open > .Select-control {
        cursor: text;
    }
    .is-open > .Select-control {
        border-bottom-right-radius: 0;
        border-bottom-left-radius: 0;
    }
    .is-open > .Select-control > .Select-arrow {
        border-color: transparent transparent
            ${({ theme }) => theme && theme.select.dropdownIndicator.default.color};
        border-width: 0 5px 5px;
    }
    .is-searchable.is-focused:not(.is-open) > .Select-control {
        cursor: text;
    }

    .Select-placeholder,
    .Select--single > .Select-control .Select-value {
        line-height: 40px;
        padding: 0 20px 0 10px;
        position: absolute;
        right: 0;
        top: 0;
        bottom: 0;
        left: 0;
        max-width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 13px;
        color: ${({ theme }) => theme && theme.select.value.default.color};
    }

    .is-focused.has-value.Select--single > .Select-control .Select-value .Select-value-label,
    .has-value.is-pseudo-focused.Select--single > .Select-control .Select-value .Select-value-label,
    .has-value.Select--single > .Select-control .Select-value .Select-value-label,
    .Select-input > input {
        color: ${({ theme }) => theme && theme.select.value.default.color};
    }

    .has-value.Select--single > .Select-control .Select-value a.Select-value-label,
    .has-value.is-pseudo-focused.Select--single
        > .Select-control
        .Select-value
        a.Select-value-label {
        cursor: pointer;
        text-decoration: none;
    }
    .has-value.Select--single > .Select-control .Select-value a.Select-value-label:hover,
    .has-value.is-pseudo-focused.Select--single
        > .Select-control
        .Select-value
        a.Select-value-label:hover,
    .has-value.Select--single > .Select-control .Select-value a.Select-value-label:focus,
    .has-value.is-pseudo-focused.Select--single
        > .Select-control
        .Select-value
        a.Select-value-label:focus {
        color: ${({ theme }) => theme && theme.select.value.default.color};
        outline: none;
        text-decoration: underline;
    }
    .Select-input {
    }
    .Select-input > input {
        width: 100%;
        background: none transparent;
        border: 0 none;
        -webkit-box-shadow: none;
        box-shadow: none;
        cursor: default;
        display: inline-block;
        font-family: inherit;
        margin: 0;
        padding: 0;
        outline: none;
        -webkit-appearance: none;
        font-size: 13px;
        top: -4px;
        position: relative;
    }
    .is-focused .Select-input > input {
        cursor: text;
    }
    .has-value.is-pseudo-focused .Select-input {
        opacity: 0;
    }
    .Select-control:not(.is-searchable) > .Select-input {
        outline: none;
    }
    .Select-loading-zone {
        cursor: pointer;
        display: table-cell;
        position: relative;
        text-align: center;
        vertical-align: middle;
        width: 16px;
    }
    .Select-loading {
        width: 16px;
        height: 16px;
        box-sizing: border-box;
        border-radius: 50%;
        display: inline-block;
        position: relative;
        vertical-align: middle;
        animation: Select-animation-spin 400ms infinite linear;
        border: 2px solid ${({ theme }) => theme && theme.select.control.default.border};
        border-right-color: ${({ theme }) => theme && theme.select.control.default.border};
    }
    .Select-clear-zone {
        cursor: pointer;
        display: table-cell;
        position: absolute;
        text-align: center;
        vertical-align: middle;
        width: 17px;
        right: 30px;
        top: 0;
        animation: Select-animation-fadeIn 200ms;
        color: ${({ theme }) => theme && theme.select.value.default.color};
    }
    .Select-clear-zone:hover {
        color: ${({ theme }) => theme && theme.select.value.default.color};
    }
    .Select-clear {
        display: inline-block;
        font-size: 18px;
        line-height: 1;
    }
    .Select--multi .Select-clear-zone {
        width: 17px;
        max-height: 40px;
        line-height: 40px;
    }
    .Select-arrow-zone {
        cursor: pointer;
        display: table-cell;
        position: absolute;
        text-align: center;
        vertical-align: middle;
        width: 8px;
        padding-right: 5px;
        right: 12px;
        max-height: 36px;
        line-height: 36px;
        top: 0;
    }
    .Select-arrow {
        border-color: ${({ theme }) => theme && theme.select.dropdownIndicator.default.color}
            transparent transparent;
        border-style: solid;
        border-width: 5px 5px 2.5px;
        display: inline-block;
        height: 0;
        width: 0;
    }
    .is-open .Select-arrow,
    .Select-arrow-zone:hover > .Select-arrow {
        border-top-color: ${({ theme }) => theme && theme.select.dropdownIndicator.hover.color};
    }
    .Select--multi .Select-multi-value-wrapper {
        display: inline-block;
    }
    .Select .Select-aria-only {
        display: inline-block;
        height: 1px;
        width: 1px;
        margin: -1px;
        clip: rect(0, 0, 0, 0);
        overflow: hidden;
    }

    .Select-menu-outer {
        border-radius: 4px;
        box-sizing: border-box;
        margin-top: 8px;
        margin-bottom: 8px;
        max-height: 200px;
        position: absolute;
        top: 100%;
        left: 0; // Firefox fix
        width: 100%;
        max-width: 1000px;
        z-index: 1;
        -webkit-overflow-scrolling: touch;
        font-size: 13px;
        background: ${({ theme }) => theme && theme.select.menu.default.background};
    }
    .Select-menu {
        border: 1px solid ${({ theme }) => theme && theme.select.menu.default.border};
        box-shadow: 0 5px 5px rgba(0, 0, 0, 0.06);
        max-height: 198px;
        overflow-y: auto;
    }
    .Select-option,
    .VirtualizedSelectOption {
        box-sizing: border-box;
        position: absolute;
        cursor: pointer;
        display: flex;
        flex: 1 1 auto;
        min-height: 34px;
        line-height: 18px;
        font-size: 13px;
        padding: 8px 10px;
        vertical-align: middle;
        align-items: center;
        transition: color, background-color 300ms;
        background-color: ${({ theme }) => theme && theme.select.option.default.background};
        color: ${({ theme }) => theme && theme.select.option.default.color};
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .Select-option:last-child,
    .VirtualizedSelectOption:last-child {
        border-bottom-right-radius: 4px;
        border-bottom-left-radius: 4px;
    }
    .Select-option.is-focused,
    .VirtualizedSelectFocusedOption {
        background-color: ${({ theme }) => theme && theme.select.option.focused.background};
    }
    .Select-option.is-selected,
    .VirtualizedSelectSelectedOption {
        border-left: 2px solid ${({ theme }) => theme && theme.select.option.selected.border};
    }

    .Select-option.is-disabled {
        color: ${({ theme }) => theme && theme.select.option.default.color};
        cursor: default;
    }
    .Select-noresults {
        box-sizing: border-box;
        cursor: default;
        display: block;
        padding: 8px 10px;
        color: ${({ theme }) => theme && theme.select.option.default.color};
    }
    .Select--multi .Select-input {
        vertical-align: middle;
        padding: 0;
    }

    .Select--multi .Select-value {
        display: inline-block;
        vertical-align: top;
        position: relative;
        margin: 2px 6px 2px 0px;
        border: none;
        color: ${({ theme }) => theme && theme.select.multiValue.default.color};
        background-color: ${({ theme }) => theme && theme.select.multiValue.default.background};
    }

    .Select--multi .Select-value-icon,
    .Select--multi .Select-value-label {
        display: inline-block;
        vertical-align: middle;
    }
    .Select--multi .Select-value-label {
        cursor: default;
        padding: 0 2px 0 8px;
        max-width: 19em;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        height: 24px;
        line-height: 24px;
        display: flex;
        flex: 1;
        font-size: 12px;
    }
    .Select--multi a.Select-value-label {
        cursor: pointer;
        text-decoration: none;
        color: ${({ theme }) => theme && theme.select.multiValue.default.color};
    }
    .Select--multi a.Select-value-label:hover {
        text-decoration: underline;
    }
    .Select--multi .Select-value-icon {
        cursor: pointer;
        padding: 0 8px;
        width: 24px;
        height: 24px;
        line-height: 24px;
        float: right;
        border: none;
        color: ${({ theme }) => theme && theme.select.multiValue.icon.default.color};
    }
    .Select--multi .Select-value-icon:hover,
    .Select--multi .Select-value-icon:focus,
    .Select--multi .Select-value-icon:active {
        color: ${({ theme }) => theme && theme.select.multiValue.icon.hover.color};
    }

    .ReactSelect .channel--icon-undo {
        .icon {
            fill: #777;
        }
        &:hover .icon {
            fill: #fff;
        }
    }

    .VirtualSelectGrid {
        z-index: 1;
    }

    @keyframes Select-animation-fadeIn {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }

    @keyframes Select-animation-spin {
        to {
            transform: rotate(1turn);
        }
    }
`;

export default selectStyles;
